export const DEMOGRAPHIC_LIST_LIMIT = 50;
